import { NavLink, Outlet } from "react-router-dom";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "./content";

const navClass = ({ isActive }) =>
    `rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
        isActive ? "bg-[#327560] text-white" : "text-[#283C43] hover:bg-[#E8F3EC]"
    }`;

export default function MarketingLayout() {
    return (
        <div className="min-h-screen bg-[#FCF9EE] text-[#283C43]">
            <header className="sticky top-0 z-50 border-b border-[#E9E2CD] bg-[#FCF9EE]/95 backdrop-blur">
                <div className="mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-3 px-5 py-3 sm:px-8">
                    <NavLink to="/" className="flex items-center gap-3" aria-label="MathMinds home">
                        <img src="/backGrounds/logo.svg" alt="" className="h-10 w-auto" />
                        <div>
                            <div className="font-chango text-xl text-[#327560]">MathMinds</div>
                            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#6B756F]">Kids Math Games</div>
                        </div>
                    </NavLink>

                    <nav aria-label="Main navigation" className="order-3 flex w-full items-center justify-center gap-1 sm:order-2 sm:w-auto">
                        <NavLink to="/" end className={navClass}>Home</NavLink>
                        <NavLink to="/math-games/" className={navClass}>For Parents</NavLink>
                        <NavLink to="/about" className={navClass}>About</NavLink>
                    </nav>

                    <div className="order-2 flex items-center gap-2 sm:order-3">
                        <NavLink to="/games/memory" className="rounded-full bg-[#F9B818] px-5 py-2.5 font-bold text-[#283C43] shadow-sm transition hover:bg-[#FFCA47]">Play games</NavLink>
                    </div>
                </div>
            </header>

            <main>
                <Outlet />
            </main>

            <footer className="mt-16 bg-[#285E50] text-white">
                <div className="mx-auto grid max-w-[1200px] gap-10 px-5 py-12 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
                    <div>
                        <div className="font-chango text-2xl">MathMinds</div>
                        <p className="mt-3 max-w-sm text-sm leading-6 text-[#DCEBE5]">
                            Playful math and brain games that help children build confidence through practice.
                        </p>
                    </div>
                    <nav aria-label="Parent resources">
                        <h2 className="font-bold">For parents</h2>
                        <ul className="mt-3 space-y-2 text-sm text-[#DCEBE5]">
                            <li><NavLink to="/math-games/" className="hover:text-white">Math games for kids</NavLink></li>
                            <li><NavLink to="/math-games/ages-4-6/" className="hover:text-white">Games for ages 4–6</NavLink></li>
                            <li><NavLink to="/math-games/ages-7-9/" className="hover:text-white">Games for ages 7–9</NavLink></li>
                            <li><NavLink to="/math-games/ages-10-15-plus/" className="hover:text-white">Games for ages 10–15+</NavLink></li>
                        </ul>
                    </nav>
                    <nav aria-label="Company and legal">
                        <h2 className="font-bold">MathMinds</h2>
                        <ul className="mt-3 space-y-2 text-sm text-[#DCEBE5]">
                            <li><NavLink to="/about" className="hover:text-white">About MathMinds</NavLink></li>
                            <li><NavLink to="/privacy_policy" className="hover:text-white">Privacy policy</NavLink></li>
                            <li><NavLink to="/terms_of_use" className="hover:text-white">Terms of use</NavLink></li>
                            <li><NavLink to="/refund_policy" className="hover:text-white">Refund policy</NavLink></li>
                        </ul>
                    </nav>
                    <section aria-labelledby="download-mathminds">
                        <h2 id="download-mathminds" className="font-bold">Get MathMinds</h2>
                        <div className="mt-4 flex flex-col items-start gap-3 text-sm text-[#DCEBE5]">
                            <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="hover:text-white hover:underline">Download on the App Store ↗</a>
                            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer" className="hover:text-white hover:underline">Get it on Google Play ↗</a>
                        </div>
                    </section>
                </div>
            </footer>
        </div>
    );
}
